import { ShipmentStatusEnum } from '../enum/shipment-status.enum';

export const defaultShipmentViews = {
    ACTIVE_SHIPMENTS: {
        caption: $localize`Active Shipments`,
        id: 'ACTIVE_SHIPMENTS',
        hide: false,
        query: {
            state: ShipmentStatusEnum.ACTIVE,
            pageNumber: 0,
            itemsPerPage: 25,
            sortColumn: 'shipmentDate',
            sortDescending: true,
            afterDate: null,
            beforeDate: null,
            filter: null,
            shipper: [],
            destination: []
        },
        columns: [
            'COURIER', 'SHIPMENT_STATUS', 'SHIPMENT_DATE', 'SHIPPER_ORGANIZATION', 'SHIPPER_CITY', 'DESTINATION_ORGANIZATION', 'DESTINATION_CITY', 'CUSTOMER_PRICE'
        ]
    },
    ALL_SHIPMENTS: {
        caption: $localize`All Shipments`,
        id: 'ALL_SHIPMENTS',
        hide: false,
        query: {
            state: ShipmentStatusEnum.ANY,
            pageNumber: 0,
            itemsPerPage: 25,
            sortColumn: 'shipmentDate',
            sortDescending: true,
            afterDate: null,
            beforeDate: null,
            filter: null,
            shipper: [],
            destination: []
        },
        columns: [
            'COURIER', 'SHIPMENT_STATUS', 'SHIPMENT_DATE', 'SHIPPER_ORGANIZATION', 'SHIPPER_CITY', 'DESTINATION_ORGANIZATION', 'DESTINATION_CITY', 'CUSTOMER_PRICE'
        ]
    },
    SUBMITTED: {
        caption: $localize`Submitted`,
        id: 'SUBMITTED',
        hide: false,
        query: {
            state: ShipmentStatusEnum.SUBMITTED,
            pageNumber: 0,
            itemsPerPage: 25,
            sortColumn: 'shipmentDate',
            sortDescending: true,
            afterDate: null,
            beforeDate: null,
            filter: null,
            shipper: [],
            destination: []
        },
        columns: [
            'COURIER', 'SHIPMENT_STATUS', 'SHIPMENT_DATE', 'SHIPPER_ORGANIZATION', 'SHIPPER_CITY', 'DESTINATION_ORGANIZATION', 'DESTINATION_CITY'
        ]
    },
    QUOTES: {
        caption: $localize`Quotes`,
        id: 'QUOTES',
        hide: false,
        query: {
            state: ShipmentStatusEnum.QUOTE,
            pageNumber: 0,
            itemsPerPage: 25,
            sortColumn: 'shipmentDate',
            sortDescending: true,
            afterDate: null,
            beforeDate: null,
            filter: null,
            shipper: [],
            destination: []
        },
        columns: [
            'SHIPMENT_STATUS', 'SHIPMENT_DATE', 'SHIPPER_ORGANIZATION', 'SHIPPER_CITY', 'DESTINATION_ORGANIZATION', 'DESTINATION_CITY'
        ]
    },
    EXCEPTIONS: {
        caption: $localize`Exceptions`,
        id: 'EXCEPTIONS',
        hide: false,
        query: {
            state: ShipmentStatusEnum.EXCEPTION,
            pageNumber: 0,
            itemsPerPage: 25,
            sortColumn: 'shipmentDate',
            sortDescending: true,
            afterDate: null,
            beforeDate: null,
            filter: null,
            shipper: [],
            destination: []
        },
        columns: [
            'COURIER', 'SHIPMENT_STATUS', 'SHIPMENT_DATE', 'TRACKING_NUMBER'
        ]
    },
};
